function addToCartWizard() {
  return {
    step: 1,
    steps: ["Chip Sticks", "Spud Dust", "Shake Bags", "Tub"],
    subscribeAndSave: false,
    deliveryFrequency: "monthly",
    bagsCount: 1,
    crispAllergen: `<div class=has-motion><div class="cf rte"><p><meta charset=utf-8><meta charset=utf-8><strong data-mce-fragment=1>Crisps Nutritional Information</strong><br><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 30g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>2218 kJ<br>533 kcal<td style=width:208.953px>665 kJ<br>160 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px>33.5g<br><td style=width:208.953px>10g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px>3.82g<br><td style=width:208.953px>1.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px>57.8g<br><td style=width:208.953px>17.3g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px>&lt;0.1g<br><td style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt;0.1g</span><br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>7.7g<br><td style=width:208.953px>2.31g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px>3.8g<br><td style=width:208.953px>1.1g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px>0g<br><td style=width:208.953px>0g<br></table><strong>Ingredients<br></strong>Potatoes, Rapeseed Oil.</div></div></div>`,
    bagPrice: 9.99,
    numberOf: 5,
    shakeBagsCount: 5,
    cartLoading: false,
    _scrollListenerAdded: false,
    flavors: [
      {
        id: 1,
        name: "Southern Fried Chicken",
        img: imgs[0],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr style=height:19px><td style=width:192px;height:19px><strong>Average</strong><td style=width:128.047px;height:19px><strong>Per 100g</strong><td style=width:208.953px;height:19px><strong>Per 5g Serving</strong><tr style=height:39px><td style=width:192px;height:39px><strong>Energy</strong><td style=width:128.047px;height:39px>1233 kJ<br>293 kcal<td style=width:208.953px;height:39px>61.65 kJ<br>14.654 kcal<br><tr style=height:19px><td style=width:192px;height:19px><strong>Fat</strong><td style=width:128.047px;height:19px>1.74g<br><td style=width:208.953px;height:19px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr style=height:19px><td style=width:192px;height:19px>    Saturated<td style=width:128.047px;height:19px><meta charset=utf-8>0.47g<br><td style=width:208.953px;height:19px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr style=height:19px><td style=width:192px;height:19px><strong>Carbohydrates</strong><br><td style=width:128.047px;height:19px>51.39g<br><td style=width:208.953px;height:19px><meta charset=utf-8>2.56g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>3.47g<br><td style=width:208.953px><meta charset=utf-8>0.17g<br><tr><td style=width:192px>    Starch<td style=width:128.047px>1.14g<td style=width:208.953px><meta charset=utf-8><span>&lt; 0.1g</span><tr style=height:19px><td style=width:192px;height:19px><strong>Fibre</strong><td style=width:128.047px;height:19px>8.07g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.40g<br><tr style=height:19px><td style=width:192px;height:19px><strong>Protein</strong><td style=width:128.047px;height:19px><meta charset=utf-8>14.09g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.70g<br><tr style=height:19px><td style=width:192px;height:19px><strong>Salt</strong><td style=width:128.047px;height:19px>16.38g<br><td style=width:208.953px;height:19px><meta charset=utf-8>0.81g<br></table></div><p><br><p><strong>Ingredients</strong><br>Rice Flour, Yeast Extract, Onion Powder, Spices (Black Pepper, Paprika, Mace, Fennel, Ginger), Salt, Garlic Powder, Herbs (Oregano, Thyme), Spice Extract<br><p><strong>Allergens</strong><br>None<p>Store in a cool dry place out of direct sunlight.<p><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 2,
        name: "Döner Kebab",
        img: imgs[1],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1293 kJ<br>308 kcal<td style=width:208.953px>64.65 kJ<br>15.4 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8>6.49g<br><td style=width:208.953px><meta charset=utf-8>0.32g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8>0.74g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>41.6g<br><td style=width:208.953px><meta charset=utf-8>2.08g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>3.47g<br><td style=width:208.953px><meta charset=utf-8>0.17g<br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>10.78g<br><td style=width:208.953px><meta charset=utf-8>0.54g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>15.39g<br><td style=width:208.953px><meta charset=utf-8>0.77g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8>18.23g<br><td style=width:208.953px><meta charset=utf-8>0.91g<br></table></div><p><br><p><strong>Ingredients</strong><br><meta charset=utf-8><span data-mce-fragment=1>Spices (Coriander, Cumin, Cayenne, Black Pepper), Rice Flour, Yeast Extract, Salt, Onion Powder, Garlic Powder, Garam Masala (coriander, cumin, black pepper, allspice, cardamom, nutmeg, turmeric, ginger, bay, clove, cassia, cayenne) contains, Acid E330, Natural Flavouring, Herbs (Mint), Dextrose, Mint Extract.</span><br><p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 3,
        name: "Salt & Vinegar",
        img: imgs[2],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1190 kJ<br>283 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>59.5 kJ<br>14.2 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>3.03g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px>0g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px>60.91g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>3g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px>9.33g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.5g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>0.16g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>3.07g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>21.51g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>1.1g<br></table></div><p><br><p><strong>Ingredients</strong><br>Spirit Vinegar, Salt, Yeast Extract, Maltodextrin, Citric Acid, Sugar.<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 4,
        name: "Prawn Cocktail",
        img: imgs[3],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1078 kJ<br>257 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>53.9 kJ<br>12.8 kcal<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1.21g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8><span data-mce-fragment=1>&lt; 0.1g</span><br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.17g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px>53.76.6g<br><td data-mce-style="width: 208.953px;"style=width:208.953px>2.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px>34.29g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>1.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>2.30g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>6.52g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.3g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>17.75g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.9g<br></table></div><p><br><p><strong>Ingredients<br></strong>Rice Flour, Sugar, Salt, Dextrose, Acidity Regulator E262(ii), Yeast Extract, Acid E330, Onion Powder, Icing Sugar, Tomato Powder, Spices (Cayenne), Natural Flavouring, Paprika Extract, Spice Extract<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 5,
        name: "Chip Shop Curry",
        img: imgs[4],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1414 kJ<br>336 kcal<td style=width:208.953px>70.7 kJ<br>16.8 kcal<br><tr><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8>3.04g<br><td style=width:208.953px><meta charset=utf-8>0.2g<br><tr><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8>0.45g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>65.6g<br><td style=width:208.953px><meta charset=utf-8>3.3g<br><tr><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>27.68g<br><td style=width:208.953px><meta charset=utf-8>1.4g<br><tr><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8>7.21g<br><td style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>8.14g<br><td style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8>14.67g<br><td style=width:208.953px><meta charset=utf-8>0.7g<br></table></div><p><br><p><strong>Ingredients</strong><br>Spices (cumin, coriander, turmeric, fennel, fenugreek, cayenne, black pepper), Sugar, Salt, Onion Powder, Yeast Extract, Garlic Powder, Maltodextrin, Tomato Powder, Paprika Extract.<p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<p>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. </div></div>`,
      },
      {
        id: 6,
        name: "Crispy Bacon",
        img: imgs[5],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1380 kJ<br>328 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>69.01 kJ<br>16.4 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.62g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.24g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>75.76g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>3.8g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>20.01g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.65g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>4.68g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.2g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>15.12g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.8g<br></table></div><p><br><p><strong>Ingredients</strong><br>Salt, Yeast Extract, Spices (black pepper, cayenne, clove, pimento), Sugar, Flavouring, Paprika Extract, Maltodextrin, Dextrose, Spice Extract <br><p><strong>Allergens</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 7,
        name: "Nooch & Onion",
        img: imgs[6],
        count: 0,
        allergen: `<div class=has-motion><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table width=100%><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Average</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><strong>Per 100g</strong><td data-mce-style="width: 208.953px;"style=width:208.953px><strong>Per 5g Serving</strong><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Energy</strong><td data-mce-style="width: 128.047px;"style=width:128.047px>1370 kJ<br>326 kcal<td data-mce-style="width: 208.953px;"style=width:208.953px>68.5 kJ<br>16.3 kcal<tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fat</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.26g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Saturated<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>0.27g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Carbohydrates</strong><br><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>72.65g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>3.6g<br><tr><td data-mce-style="width: 192px;"style=width:192px>    Sugars<td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>13.84g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.7g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Fibre</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>1.86g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Protein</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>7.44g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.4g<br><tr><td data-mce-style="width: 192px;"style=width:192px><strong>Salt</strong><td data-mce-style="width: 128.047px;"style=width:128.047px><meta charset=utf-8>14.69g<br><td data-mce-style="width: 208.953px;"style=width:208.953px><meta charset=utf-8>0.7g<br></table></div><p><br><p><strong>Ingredients</strong><br>Yeast Extract, Onion Powder (<strong>sulphites</strong>), Sugar (<strong>sulphites</strong>), Paprika Extract, Maltodextrin (<strong>sulphites</strong>), Salt, Natural Flavouring.<br><p><strong>Allergies</strong><br>In bold.<br><p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
      {
        id: 8,
        name: "Nduja & Honey",
        img: imgs[7],
        count: 0,
        allergen: `<div class="has-motion"><div class="cf rte"><p><strong>Nutrition Information</strong><div class=nutrition_information><table style=height:195.938px width=100%><tr style=height:19.5938px><td style=width:192px><strong>Average</strong><td style=width:128.047px><strong>Per 100g</strong><td style=width:208.953px><strong>Per 5g Serving</strong><tr style=height:39.1875px><td style=width:192px><strong>Energy</strong><td style=width:128.047px>1322.5 kJ<br>331.9 kcal<td style=width:208.953px>66.1 kJ<br>16.6 kcal<br><tr style=height:19.5938px><td style=width:192px><strong>Fat</strong><td style=width:128.047px><meta charset=utf-8> 3.43g<br><td style=width:208.953px><meta charset=utf-8> 0.17g<br><tr style=height:19.5938px><td style=width:192px>    Saturated<td style=width:128.047px><meta charset=utf-8> 0.64g<br><td style=width:208.953px><meta charset=utf-8>&lt; 0.1g<br><tr style=height:19.5938px><td style=width:192px><strong>Carbohydrates</strong><br><td style=width:128.047px><meta charset=utf-8>57.4g<br><td style=width:208.953px><meta charset=utf-8>2.87g<br><tr style=height:19.5938px><td style=width:192px>    Sugars<td style=width:128.047px><meta charset=utf-8>44.2g<br><td style=width:208.953px><meta charset=utf-8>2.21g<br><tr style=height:19.5938px><td style=width:192px><strong>Fibre</strong><td style=width:128.047px><meta charset=utf-8> 7.20g<br><td style=width:208.953px><meta charset=utf-8> 0.36g<br><tr style=height:19.5938px><td style=width:192px><strong>Protein</strong><td style=width:128.047px><meta charset=utf-8>10g<br><td style=width:208.953px><meta charset=utf-8> 0.5g<br><tr style=height:19.5938px><td style=width:192px><strong>Salt</strong><td style=width:128.047px><meta charset=utf-8> 17.7g<br><td style=width:208.953px><meta charset=utf-8> 0.88g<br></table></div><p><br><p><strong>Ingredients</strong><br><meta charset=utf-8><span dir=ltr role=presentation>Spices (Cayenne, Paprika), Sugar, Dextrose, Salt, Yeast Extract, Icing Sugar, Garlic </span><span dir=ltr role=presentation>Powder, Natural Flavouring, </span><span dir=ltr role=presentation>Acid E330, Paprika Extract, Spice Extract.</span><span dir=ltr role=presentation></span><br><p><strong>Allergies</strong><br>None<p>Store in a cool dry place out of direct sunlight.<br><br><meta charset=utf-8>Manufacturing site handles gluten, egg, fish, soybeans, milk, celery, sulfur dioxide and mustard. <br></div></div>`,
      },
    ],
    selectedFlavors: [],
    tub: 0,
    tubPrice: 4.99,
    swiperInstance: null,
    modalHeader: null,
    modalText: null,
    modalClose: null,
    modalContinue: null,
    modalOpen: false,
    allergensContent: "",

    init() {
      const url = new URL(window.location);

      if (this.step === 1 && !url.searchParams.has("step")) {
        history.pushState({}, "");
        this.updateState();
      }

      if (url.searchParams.has("subscribe")) {
        if (url.searchParams.get("subscribe") === "1") {
          this.deliveryFrequency = "twomonths";
        }
        if (url.searchParams.get("subscribe") === "2") {
          this.deliveryFrequency = "monthly";
        }
        if (url.searchParams.get("subscribe") === "3") {
          this.deliveryFrequency = "biweekly";
        }
        this.subscribeAndSave = true;
      }

      setTimeout(() => {
        this.initSwiper();
        this.onScrollFlavors();
        this.onScrollNextButton();

        window.addEventListener("resize", this.onResize.bind(this));
        window.scrollTo(0, 0);
      }, 0);

      window.addEventListener("popstate", (event) => {
        if (event.state) {
          const state = event.state;
          this.step = state.step ?? 1;
          this.bagsCount = state.bagsCount ?? 1;
          this.numberOf = 5 * this.bagsCount;

          this.shakeBagsCount = Math.min(
            state.shakeBagsCount ?? this.numberOf,
            this.numberOf
          );
          this.tub = state.tub ?? 0;

          if (state.selectedFlavors) {
            let total = 0;
            this.flavors.forEach((flavor) => {
              const savedFlavor = state.selectedFlavors.find(
                (f) => f.id === flavor.id
              );
              if (savedFlavor) {
                if (total + savedFlavor.count > this.numberOf) {
                  flavor.count = 0;
                } else {
                  flavor.count = savedFlavor.count;
                }
                total += flavor.count;
              } else {
                flavor.count = 0;
              }
            });
          }
        }
      });
    },

    getState() {
      const state = {
        step: this.step,
        bagsCount: this.bagsCount,
        shakeBagsCount: this.shakeBagsCount,
        tub: this.tub,
        selectedFlavors: this.flavors.map((flavor) => ({
          id: flavor.id,
          count: flavor.count,
        })),
      };
      return state;
    },

    updateState() {
      const state = this.getState();

      const url = new URL(window.location);
      url.searchParams.set("step", this.step);
      history.pushState(state, "", url);
    },

    onResize() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }
      this.initSwiper();
    },

    destroy() {
      window.removeEventListener("resize", this.onResize.bind(this));
    },

    waitForImagesToLoad(containerSelector) {
      const container = document.querySelector(containerSelector);
      if (!container) {
        return Promise.resolve();
      }

      const images = container.querySelectorAll("img");
      const imagePromises = Array.from(images).map((img) => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.addEventListener("load", resolve);
            img.addEventListener("error", resolve);
          }
        });
      });

      return Promise.all(imagePromises);
    },

    initSwiper() {
      const swiperElement = document.querySelector(".swiper");
      if (!swiperElement || swiperElement.offsetParent === null) {
        return;
      }

      this.waitForImagesToLoad(".swiper").then(() => {
        const slides = swiperElement.querySelectorAll(".swiper-slide");
        if (slides.length === 0) {
          return;
        }

        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }

        if (slides.length === 1) {
          swiperElement.style.padding = "0 0 0 0";
        }

        this.swiperInstance = new Swiper(".swiper", {
          loop: slides.length > 1,
          autoHeight: true,
          pagination: {
            el: ".swiper-pagination",
          },
        });
      });
      document.querySelector(".crisp-kit").classList.add("is-flavor");
    },

    setSubscribeAndSave() {
      this.subscribeAndSave = !this.subscribeAndSave;
      this.initSwiper();
    },

    nextStep() {
      if (this.step === 2) {
        if (this.getRemainingSelections() === this.numberOf) {
          this.modalHeader = "You’ve not selected any sachets.";
          this.modalText = "Are you sure you don’t want any Spud Dust sachets?";
          this.modalClose = "Oops, pick sachets";
          this.modalContinue = "I’m good, move on";
          this.openModal();
          return;
        }
        if (
          this.getRemainingSelections() < this.numberOf &&
          this.getRemainingSelections() > 1
        ) {
          this.modalHeader =
            "You have " +
            this.getRemainingSelections() +
            " selections remaining";
          this.modalText =
            "Are you sure you don’t want more Spud Dust sachets?";
          this.modalClose = "Oops, pick sachets";
          this.modalContinue = "I’m good, move on";
          this.openModal();
          return;
        }
      }
      if (this.step === 3) {
        if (this.shakeBagsCount === 0) {
          this.modalHeader = "You’ve not selected any shake bags.";
          this.modalText = "Are you sure you don’t want any shake bags?";
          this.modalClose = "Oops, add bags";
          this.modalContinue = "I’m good, move on";
          this.openModal();
          return;
        }
      }
      this.step++;
      this.updateState();
      this.init();
    },

    setStep(step) {
      if (step != 5 && step > this.step) {
        return;
      }
      this.step = step;
      this.updateState();
      this.init();
    },

    setBagsCount(count) {
      if (count >= 11) {
        return;
      }
      const oldBagsCount = this.bagsCount;
      this.bagsCount = count;
      this.numberOf = 5 * count;

      this.shakeBagsCount = this.numberOf;
      let totalFlavors = this.flavors.reduce((sum, f) => sum + f.count, 0);
      if (totalFlavors > this.numberOf) {
        this.flavors.forEach((f) => (f.count = 0));
      }

      if (this.shakeBagsCount > this.numberOf) {
        this.shakeBagsCount = this.numberOf * this.bagsCount;
      }

      if (this.tub > this.bagsCount) {
        this.tub = 0;
      }

      const state = this.getState();
      history.replaceState(state, "");
    },

    onScrollFlavors() {
      const header = document.querySelector(
        ".crisp-kit-content-header-flavors"
      );
      if (header) {
        document.querySelector(".crisp-kit").classList.add("is-flavor");
      } else {
        if (document.querySelector(".is-flavor")) {
          document.querySelector(".crisp-kit").classList.remove("is-flavor");
          this.initSwiper();
        }
        return;
      }

      document.addEventListener("scroll", () => {
        const scrollTop = header.offsetTop - document.body.scrollTop;
        if (scrollTop > 254) {
          header.classList.add("scrolled");
        } else {
          header.classList.remove("scrolled");
        }
      });
    },

    onScrollNextButton() {
      const nextStepContainer = document.querySelector(".next-step-container");
      if (!nextStepContainer) return;
      const checkSticky = () => {
        const rect = nextStepContainer.getBoundingClientRect();
        const isSticky = rect.bottom >= window.innerHeight;

        if (!isSticky) {
          nextStepContainer.classList.add("not-sticky");
        } else {
          nextStepContainer.classList.remove("not-sticky");
        }
      };
      checkSticky();
      window.addEventListener("scroll", checkSticky);
    },

    viewAllergens(id) {
      const allergen = this.flavors[id - 1].allergen;
      if (allergen) {
        this.modalHeader = this.flavors[id - 1].name;
        this.modalText = allergen;
        this.modalClose = "Close";
        this.modalContinue = "";
        this.openModal();
      }
    },

    crispAllergens() {
      const allergen = this.crispAllergen;
      if (allergen) {
        this.modalHeader = "Chip Sticks";
        this.modalText = allergen;
        this.modalClose = "Close";
        this.modalContinue = "";
        this.openModal();
      }
    },

    increaseFlavor(id) {
      const totalSelected = this.flavors.reduce((sum, f) => sum + f.count, 0);
      if (totalSelected >= this.numberOf) {
        return;
      }

      const flavor = this.flavors.find((f) => f.id === id);
      if (flavor) flavor.count++;
      const state = this.getState();
      history.replaceState(state, "");
    },

    decreaseFlavor(id) {
      const flavor = this.flavors.find((f) => f.id === id);
      if (flavor && flavor.count > 0) flavor.count--;
      const state = this.getState();
      history.replaceState(state, "");
    },

    getFlavorCount(id) {
      const flavor = this.flavors.find((f) => f.id === id);
      return flavor ? flavor.count : 0;
    },

    getRemainingSelections() {
      const totalSelected = this.flavors.reduce((sum, f) => sum + f.count, 0);
      return this.numberOf - totalSelected;
    },

    setShakeBagsCount(count) {
      this.shakeBagsCount = count;
      const state = this.getState();
      history.replaceState(state, "");
    },

    setTub(count) {
      this.tub = count;
      if (count >= this.bagsCount) {
        return;
      }
      const state = this.getState();
      history.replaceState(state, "");
    },

    openModal() {
      this.modalOpen = true;
      setTimeout(() => {
        const modalContent = document.querySelector(".modal-content");
        if (modalContent) {
          modalContent.scrollTop = 0;
        }
      }, 10);
    },

    closeModal() {
      this.modalOpen = false;
    },

    continueModal() {
      this.closeModal();
      this.step++;
      this.updateState();
      this.init();
    },

    getPrice() {
      let totalPrice = 0;
      let oldPrice = 0;

      if (this.bagsCount > 0) {
        totalPrice += 9.99;
        oldPrice += 9.99;

        if (this.bagsCount > 1) {
          totalPrice += (this.bagsCount - 1) * 9;
          oldPrice += (this.bagsCount - 1) * 9;
        }
      }

      totalPrice += this.tub * this.tubPrice;
      oldPrice += this.tub * this.tubPrice;

      if (this.subscribeAndSave) {
        totalPrice *= 0.9;
        return (
          "<s>£" +
          oldPrice.toFixed(2) +
          "</s> <span>£" +
          totalPrice.toFixed(2) +
          "</span>"
        );
      }
      return "£" + totalPrice.toFixed(2);
    },

    addToCart() {
      const selectedFlavors = this.flavors.filter((f) => f.count > 0);
      const selectedFlavorNames = selectedFlavors.map(
        (f) => f.count + " " + f.name
      );

      const bagID =
        this.bagsCount === 1
          ? "56732959998339"
          : this.bagsCount === 2
          ? "56732960031107"
          : this.bagsCount === 3
          ? "56732960063875"
          : this.bagsCount === 4
          ? "56732960096643"
          : this.bagsCount === 5
          ? "56732960129411"
          : this.bagsCount === 6
          ? "56732960162179"
          : this.bagsCount === 7
          ? "56732960194947"
          : this.bagsCount === 8
          ? "56732960227715"
          : this.bagsCount === 9
          ? "56732960260483"
          : this.bagsCount === 10
          ? "56732960293251"
          : "";

      const items = [];

      items.push({
        id: bagID,
        quantity: 1,
        properties: {
          Shakebags:
            this.shakeBagsCount > 0 ? `Yes (${this.shakeBagsCount})` : "No",
          Sachets: selectedFlavorNames.join(", "),
        },
      });

      if (this.tub > 0) {
        items.push({ id: "42958480310527", quantity: this.tub });
      }

      this.cartLoading = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      }).then((response) => {
        if (response.ok) {
          document.dispatchEvent(
            new CustomEvent("dispatch:cart-drawer:open", {
              bubbles: true,
            })
          );
          document.dispatchEvent(
            new CustomEvent("dispatch:cart-drawer:refresh", {
              bubbles: true,
            })
          );

          this.cartLoading = false;
          this.setStep(5);
          document.querySelector(".crisp-kit").classList.remove("crisp-kit");
          document.querySelector(".crips-kit-nav").style.display = "none";
          document
            .querySelector(".crisp-kit-full")
            .classList.remove("crisp-kit-full");
          document.body.classList.remove("fixed");
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
          history.pushState({}, "");
        } else {
          console.error("Error adding to cart:", response.statusText);
        }
      });
    },
  };
}
